import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AutorizacionesAccordionEfector } from "./Accordions/AutorizacionesAccordionEfector";
import { AutorizacionesAccordionPrescriptor } from "./Accordions/AutorizacionesAccordionPrescriptor";
import { AutorizacionesAccordionMateriales } from "./Accordions/AutorizacionesAccordionMateriales";

import {
  deletePractica,
  getEfectorDenunciaInternacion,
  setearEstadoEnCantidadFechaPracticaDenuncia,
  setearValorEnPractica,
  setearValorEnPracticaPendienteDenuncia,
} from "../../../actions/autorizaciones/Autorizaciones";
import { AUTORIZACIONES_PRACTICAS_ESTADOS, AUTORIZACIONES_SOLICITUDES_ESTADOS, AUTORIZACIONES_TIPO_EFECTOR, PRACTICA_APERTURA_DENUNCIA_INTERNACION } from "../../../utils/constants";
import { Button, Checkbox, FormControlLabel, FormGroup, Radio, RadioGroup, TextField, Tooltip, Typography } from "@material-ui/core";
import LetterX from "../UI/LetterX";
import { ModalPracticaCantidadFecha } from '../gestionAuditoria/ModalPracticaCantidadFecha';
import { Announcement } from '@material-ui/icons';

const PracticaTipoSolDenunciaInt = (props) => {
  const dispatch = useDispatch();
  const { solicitudSeleccionada } = useSelector((state) => state.autorizaciones);

  const [openModal, setOpenModal] = useState(false);

  const disabledProp = props.disabled ? true : false;
  const disabledPr = props.filtros?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA
    || props.filtros?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.RECHAZADA
    || props.filtros?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUTORIZADA
    || props.filtros?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.INTERNACION_PAIS
    || props.filtros?.idEstadoSolicitud === AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_TERRENO
    || props.pendiente === undefined;

  return (
    <div style={{ marginBottom: "2.8rem" }}>
      {props.practica.idCodNom === PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM &&
        <AutorizacionesAccordionEfector
          idTipoEfector={AUTORIZACIONES_TIPO_EFECTOR.INSTITUCINOAL_DISPONIBLE}
          disabled={props.disabled || solicitudSeleccionada?.idEstadoSolicitud ===
            AUTORIZACIONES_SOLICITUDES_ESTADOS.AUDITORIA_ADMINISTRATIVA}
          practica={props.practica}
          preEfector={
            !!props.practica.idCartillaPrestador
              ? props.practica.efectorInstitucional
              : null
          }
          emailEfectorI={props.practica.emailEfectorI}
          celularEfectorI={props.practica.celularEfectorI}
          emailEfectorIError={props.practica.emailEfectorIError}
          celularEfectorIError={props.practica.celularEfectorIError}
          setearEfector={(idEfector) => {
            dispatch(
              setearValorEnPractica(
                props.practica?.idCodNom,
                "idEfectorFacturacion",
                idEfector
              )
            );
          }}
          setearEfectorP={(idEfector) => {
            dispatch(
              setearValorEnPractica(
                props.practica?.idCodNom,
                "idCartillaPrestador",
                idEfector
              )
            );
          }}
          setearContactoEfectorI={props.handleInputContactosEfectorIChange}
          setearCopiarEfectorF={(value) => {
            dispatch(
              setearValorEnPractica(
                props.practica.idCodNom,
                "copiaEfectorInstitucional",
                value
              )
            );
          }}
          desdeAuditar={props.desdeAuditar}
          conInternacion={props.conInternacion}
          traerEfectores={getEfectorDenunciaInternacion}
          estaCorrecto={props.tieneEfectorInstitucional}
          showZonaLocalidad={false}
          esDenunciaInternacion={props.esDenunciaInternacion}
        />
      }
      {props.practica.idCodNom !== PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM &&
        <>
          <div
            style={{
              padding: "1rem",
              marginTop: "1.0rem",
              marginBottom: props.desdeAuditar ? 0 : "0.5rem",
              marginRight: "1rem",
              marginLeft: "1rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            {(
              !disabledProp && (props.practica.idSolicitudDenunciaInternacion !== undefined && props.practica.idSolicitudDenunciaInternacion > 0)
            ) && (
                <LetterX
                  deleteFunction={() => {
                    dispatch(deletePractica(props.practica?.idCodNom));
                  }}
                  styles={{
                    cursor: "pointer",
                    position: "relative",
                    top: "0.25rem",
                    marginRight: "0.5rem",
                  }}
                />
              )}
            <Typography variant="h6" style={{ flexGrow: 1, fontSize: "1.1rem", marginRight: 20, width: "90%" }}>
              {`${props.practica?.practica?.codNom} - ${props.practica?.practica?.desNom}`}
            </Typography>
            {props.practica.idSolicitudDenunciaInternacion !== undefined && props.practica.idSolicitudDenunciaInternacion > 0 &&
              <TextField
                style={{
                  width: "10%",
                  position: "relative",
                  bottom: "1.2rem",
                  marginTop: 20,
                  minWidth: 65,
                }}
                variant="outlined"
                type="number"
                label="Cantidad"
                value={props.cantidad}
                disabled={disabledProp || props.practica.idSolicitudDenunciaInternacion === null}
                onChange={(e) => {
                  props.setCantidad(e.target.value);
                  dispatch(
                    setearValorEnPractica(
                      props.practica?.idCodNom,
                      "cant",
                      Number(e.target.value)
                    )
                  );
                }}
                error={props.cantidad <= 0}
                helperText={props.cantidad <= 0 && "Debe ser mayor a 0."}
              />
            }
            {props.practica.idCodNom !== PRACTICA_APERTURA_DENUNCIA_INTERNACION.ID_COD_NOM
              && props.practica.idSolicitudDenunciaInternacion === null &&
              <>
                <Button
                  style={{ marginBottom: props.practica.idSolicitudDenunciaInternacion === null && 50 }}
                  onClick={() => setOpenModal(true)}
                  variant="contained"
                  color="primary"
                >
                  Cantidades
                </Button>
                {props.practica.tieneCantidadFechaPendiente &&
                  <Tooltip title='Esta práctica tiene cantidades pendientes'>
                    <Announcement style={{ color: 'red', marginLeft: 5 }} />
                  </Tooltip>
                }
              </>
            }
            {openModal &&
              <ModalPracticaCantidadFecha
                open={openModal}
                practica={props.practica}
                pendiente={props.pendiente}
                disabled={props.practica?.idEstadoPractica === AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO
                  || disabledPr
                }
                onClose={() => setOpenModal(false)}
              />
            }
          </div>
          {
            <FormGroup row>
              <FormControlLabel
                style={{
                  marginLeft: 35,
                  marginTop: props.pendiente ? -40 : -70,
                  marginBottom: props.pendiente ? 50 : 40
                }}
                control={
                  <Checkbox
                    checked={!!props.practica?.recuperoSur}
                    disabled={disabledPr}
                    onChange={(e) => {
                      dispatch(
                        setearValorEnPracticaPendienteDenuncia(
                          props.practica?.idCodNom,
                          "recuperoSur",
                          e.target.checked
                        )
                      );
                    }}
                  />
                }
                label="SURGE"
              />
            </FormGroup>}
          {props.practica.idSolicitudDenunciaInternacion === null && (
            <RadioGroup
              row
              style={{ justifyContent: "space-evenly", marginTop: -50, marginBottom: 25 }}
              value={props.practica?.idEstadoPractica?.toString()}
              onChange={(e) => {
                if (props.pendiente) {
                  dispatch(
                    setearValorEnPracticaPendienteDenuncia(
                      props.practica?.idCodNom,
                      "idEstadoPractica",
                      parseInt(e.target.value)
                    )
                  );
                } else {
                  dispatch(
                    setearValorEnPractica(
                      props.practica?.idCodNom,
                      "idEstadoPractica",
                      parseInt(e.target.value)
                    )
                  );
                }

                if (parseInt(e.target.value) === AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO || parseInt(e.target.value) === AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO) {
                  props.practica?.cantidadesFecha?.forEach(item =>
                    dispatch(setearEstadoEnCantidadFechaPracticaDenuncia(props.practica?.idCodNom, item.fecha, item.horario, parseInt(e.target.value), props.pendiente))
                  );
                }

                if (props.evaluarPracticasMateriales && parseInt(e.target.value) === AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO)
                  props.evaluarPracticasMateriales();
              }}
            >
              <FormControlLabel
                label={"Autorizada"}
                value={AUTORIZACIONES_PRACTICAS_ESTADOS.AUTORIZADO.toString()}
                control={<Radio />}
                disabled={disabledPr}
              />
              <FormControlLabel
                label={"Gestión"}
                value={AUTORIZACIONES_PRACTICAS_ESTADOS.GESTION.toString()}
                control={<Radio />}
                disabled={disabledPr}
              />
              <FormControlLabel
                label={"Rechazada"}
                value={AUTORIZACIONES_PRACTICAS_ESTADOS.RECHAZADO.toString()}
                control={<Radio />}
                disabled={disabledPr}
              />
            </RadioGroup>
          )}
          <AutorizacionesAccordionPrescriptor
            prePrescriptor={
              !!props.practica.idPrescriptor ? props.practica.prescriptor : null
            }
            setearEfector={(idEfector) => {
              dispatch(
                setearValorEnPractica(
                  props.practica.idCodNom,
                  "idPrescriptor",
                  idEfector
                )
              );
            }}
            // disabled={disabledProp}
            disabled={true}
            estaCorrecto={props.tieneIdPrescriptor}
            esDenunciaInternacion={props.esDenunciaInternacion}
            practica={props.practica}
          />
          {props.mostrarMateriales && (
            <AutorizacionesAccordionMateriales
              noMostrarEstado={true}
              practica={props.practica}
              disabled={props.disabled}
              desdeAuditar={props.desdeAuditar}
              estaCorrecto={props.tieneMinimoUnMaterial}
              esDenunciaInternacion={props.esDenunciaInternacion}
              idTipoSolicitud={solicitudSeleccionada?.idTipoSolicitud}
            />
          )}
        </>
      }
    </div>
  );
};

export default PracticaTipoSolDenunciaInt;
